import helper from '../../helper';

export default {
	state: {
		receivablesSubjects: {
			loading: false,
			data: [],
		},
		invoicingFirm: {
			loading: false,
			data: {
				list: [],
			},
		},
	},
	mutations: {
		requestSubjects(state) {
			state.receivablesSubjects.loading = true;
		},
		successSubjects(state, data) {
			state.receivablesSubjects.data = data;
		},
		failSucjects(state) {
			state.receivablesSubjects.loading = false;
		},

		requestFirm(state) {
			state.invoicingFirm.loading = true;
		},
		successFirm(state, data) {
			state.invoicingFirm.data = data;
		},
		failFirm(state) {
			state.invoicingFirm.loading = false;
		},
		resetFirm(state) {
			state.invoicingFirm.loading = false;
			state.invoicingFirm.data = {
				list: [],
			};
		},
	},
	actions: {
		// 根据sflx_id获取收费科目下拉列表
		async getSubjects({ commit }, params) {
			return helper(this, async () => {
				commit('requestSubjects');
				const res = await a.api('getSfkm', params);
				commit('successSubjects', res.result);
			});
		},
		// 获取开票厂商
		async getInvoicingFirm({ commit }, params) {
			return helper(this, async () => {
				commit('requestFirm');
				const res = await a.api('getKpCs', params);
				commit('successFirm', res.result);
			});
		},
	},
};
